import {
  CaretDownOutlined,
  CaretUpOutlined,
  MenuOutlined,
  RightOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { setIsFromAdminPreview } from "actions/courseManagement";
import { showMenu } from "actions/layout";
import { logout } from "actions/login";
import { fetchStudentStandards } from "actions/schedule";
import {
  checkLiveCourse,
  getCartCount,
  getUserCourseAutocompleteSearch,
  getUserMarketPlaceCoursesData,
  getUserMarketPlaceHomeData,
  setIsDownloadBarVisible,
  setIsLogoutClicked,
  setIsMyAccountClicked,
  setParentLink,
  setSelectedSuggestion,
  setShowContactBar,
  setSideBarStudentHome,
  storeCartCountData,
} from "actions/studentMarketPlace";
import { AutoComplete, Dropdown, Menu, Tooltip, Typography } from "antd";
import { Button } from "components/Button";
import PageDataLoader from "components/pageDataLoader";
import LogoutConfirm from "layout/logoutConfirm";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Api, Notification } from "services";
import { IMG_URL } from "../../env.json";
import ContactUsTopBar from "./contactUsTopBar";
import DownloadAppTopBar from "./downloadAppTopBar";
import MobileDiscountOffersCarousel from "./mobileDiscountOffersCarousel";
import OffersCarousel from "./offersCarousel";
import "./userHomeStyles.css";
import UserAvatar from "components/userAvatar";
import DownloadAppModal from "./downloadAppModal";
import LoginModal from "pages/login-new/loginModal";
import {
  setRegisterSuccessModal,
  setShowBottomSheet,
  setShowDownloadAppModal,
  setShowLoginModal,
} from "actions/loginNew";
import SuccessModal from "pages/login-new/successModal";
import defaultInstituteLogo from "../../Assets/noinstitute.png";
import OfferCarouselV2 from "./offerCarouselV2";

function TopBar({
  hideCart,
  fullWidth,
  exploreCourses,
  userMarketPlaceHomeData,
  orgData,
  user,
  logout,
  setSideBarStudentHome,
  setParentLink,
  getUserCourseAutocompleteSearch,
  showMenu,
  cartCountData,
  getUserMarketPlaceHomeData,
  setIsLogoutClicked,
  isLogoutClicked,
  storeCartCountData,
  getCartCount,
  setIsMyAccountClicked,
  setIsCategoryClicked,
  isCategoryClicked,
  setIsProfileClicked,
  isProfileClicked,
  setIsDownloadBarVisible,
  isDownloadBarVisible,
  autocompleteSearched,
  showContactBar,
  setShowContactBar,
  setSelectedSuggestion,
  selectedSuggestion,
  isFromAdminPreview,
  setIsFromAdminPreview,
  isOffersBarVisible,
  offersCarouselData,
  couponList,
  setCategories,
  SetHidBanner,
  setCategoryId,
  setPage,
  setCourses,
  userSearchData,
  getUserMarketPlaceCoursesData,
  setHasMore,
  page,
  showLoginModal,
  setShowLoginModal,
  setRegisterSuccessModal,
  showRegisterSuccessModal,
  showDownloadAppModal,
  setShowDownloadAppModal,
  showBottomSheet,
  setShowBottomSheet,
  fetchStudentStandards,
  checkLiveCourse,
}) {
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const history = useHistory();
  const [confirmLogoutVisible, setConfirmLogoutVisible] = useState(false);
  const [autocompleteSearchedValue, setAutocompleteSearchedValue] =
    useState(null);
  const [searchLoader, setSearchLoader] = useState(null);
  const [userSearchDataContainer, setUserSearchData] = useState(null);
  const [pageLoader, togglePageLoader] = useState(false);

  const footerRef = useRef(null); // Create a ref for Footer
  const profileRef = useRef(null);

  // userMarketPlaceHomeData comes from the marketplace service, which can be
  // offline/unreachable - orgData is loaded via the core login API and is
  // already available in this case, so fall back to it before giving up and
  // showing the generic placeholder.
  const topBarLogoSrc = userMarketPlaceHomeData?.orgLogo
    ? `${Api._s3_url}${userMarketPlaceHomeData.orgLogo}`
    : orgData?.logo
    ? `${Api._s3_url}${orgData.logo}`
    : defaultInstituteLogo;
  // Same reasoning applies to the institute name - don't let it disappear
  // (e.g. on student-test's topbar) just because the marketplace is offline.
  const topBarOrgName = userMarketPlaceHomeData?.orgName || orgData?.title;

  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (!isProfileClicked) return;
    const handleOutsideClick = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setIsProfileClicked(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isProfileClicked]);

  useEffect(() => {
    getUserMarketPlaceHomeData(true, () => { });
  }, []);

  const handleLogout = () => {
    const reason = {
      type: "Manual",
    };
    logout(history, reason, true);
    setConfirmLogoutVisible(false);
    setIsLogoutClicked(true);
    history.push("/");
    togglePageLoader(true);
    if (isLogoutClicked) {
      storeCartCountData(0);
    } else {
      getCartCount();
    }

    getUserMarketPlaceHomeData(undefined, () => {
      togglePageLoader(false);
      storeCartCountData(0);
    });
    if (setCourses) {
      setCourses([]);
      const requestsParams = {
        page: 1,
        courseType: "course",
        limit: 3,
      };
      getUserMarketPlaceCoursesData(requestsParams, (data) => {
        if (data?.items && data?.items?.length > 0) {
          setCourses((prevCourses) => [...prevCourses, ...data?.items]);
        }
        if (data?.items?.length < requestsParams?.limit) {
          setHasMore?.(false);
        }
      });
    }
  };

  const handleChangeCategory = (cId, category, subCategory) => {
    setParentLink({ parentName: category, childName: subCategory });
    history.push({
      pathname: "/all-popular-courses",
      state: {
        categoryId: cId,
      },
    });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsCategoryClicked(false);
      setIsProfileClicked(false);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const filterSubCategoryMenu = (category, index) => (
    <Menu
      className="scroll-bar-universal"
      style={{
        height: "fit-content",
        backgroundColor: "#FFFFFF",
        boxShadow: " 4px 4px 16px #00000014",
        width: 230,
        borderRadius: 8,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        margin: index == 0 ? "40px 0px 0px -2px" : "0px 0px 0px -2px",
      }}
    >
      {category?.children &&
        category?.children?.map((subcategory) => (
          <div
            className="dropmenuBp"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: 45,
            }}
            onClick={() => {
              handleChangeCategory(
                subcategory?.id,
                category?.name,
                subcategory?.name
              );
              setAutocompleteSearchedValue(null);
              setSelectedSuggestion(null);
            }}
          >
            <Typography.Text
              ellipsis={{ tooltip: true }}
              style={{ color: "#191919", width: 210, fontWeight: 550 }}
            >
              {subcategory?.name}
            </Typography.Text>
          </div>
        ))}
    </Menu>
  );
  const userCategoryMenu = (
    <Menu
      className="scroll-bar-universal"
      style={{
        height:
          userMarketPlaceHomeData?.categories?.length > 5 ? 280 : "fit-content",
        backgroundColor: "#FFFFFF",
        boxShadow: " 4px 4px 16px #00000014",
        width: 230,
        borderRadius: 8,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        marginTop: -3,
      }}
    >
      {userMarketPlaceHomeData?.categories &&
        userMarketPlaceHomeData?.categories?.map((category, index) => (
          <Dropdown
            overlay={filterSubCategoryMenu(category, index)}
            placement="right"
            trigger={["hover"]}
          >
            <div
              className="dropmenuBp"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: 45,
              }}
            >
              <Typography.Text
                ellipsis={{ tooltip: true }}
                style={{ color: "#191919", width: 210, fontWeight: 550 }}
              >
                {category?.name}
              </Typography.Text>
              <RightOutlined style={{ color: "#AEAEAE" }} />
            </div>
          </Dropdown>
        ))}
    </Menu>
  );

  const handleAutocompleteSearch = (value) => {
    setIsCategoryClicked(false);
    setIsProfileClicked(false);
    setAutocompleteSearchedValue(value);
    setSearchLoader(true);
    getUserCourseAutocompleteSearch(value, (response) => {
      setUserSearchData(response);
      setSearchLoader(false);
    });
  };

  const renderTitle = (title) => (
    <div style={{ color: "#636363", fontSize: 16, marginLeft: 10 }}>
      {title}
    </div>
  );

  const searchOptions = [
    {
      label:
        userSearchDataContainer?.suggestions?.length != 0
          ? renderTitle("Suggestions")
          : null,
      options: userSearchDataContainer?.suggestions?.length
        ? userSearchDataContainer?.suggestions?.map((item) => ({
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "fit-content",
                padding: "3px 0px",
              }}
              onClick={() => {
                history.push({
                  pathname: "/all-popular-courses",
                  state: { fromSearch: true /* selectedSuggestion: item */ },
                });
                setSelectedSuggestion(item);
              }}
            >
              <SearchOutlined />
              <Typography.Text
                ellipsis={{ tooltip: true }}
                style={{
                  color: "#191919",
                  fontWeight: 600,
                  marginLeft: 10,
                  width: 230,
                }}
              >
                {item}
              </Typography.Text>
            </div>
          ),
        }))
        : [],
    },
    {
      label:
        userSearchDataContainer?.resources?.length != 0
          ? renderTitle("Courses")
          : null,
      options: userSearchDataContainer?.resources?.length
        ? userSearchDataContainer?.resources?.map((item) => ({
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "fit-content",
                padding: "5px 0px",
              }}
              onClick={() => {
                history.push({
                  pathname: "/all-popular-courses",
                  state: {
                    fromSearch: true /* selectedSuggestion: item?.name  */,
                  },
                });
                setSelectedSuggestion(item?.name);
              }}
            >
              <img
                src={`${Api.dlS3Url}${item?.image}`}
                style={{ width: 40, height: 30 }}
              />
              <Typography.Text
                ellipsis={{ tooltip: true }}
                style={{
                  color: "#191919",
                  fontWeight: 600,
                  marginLeft: 10,
                  width: 230,
                }}
              >
                {item?.name}
              </Typography.Text>
            </div>
          ),
        }))
        : [],
    },
  ];
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 800) {
        const currentScrollPos = window.pageYOffset;
        setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 100);
        setPrevScrollPos(currentScrollPos);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  useEffect(() => {
    if (window.performance.navigation.type === 0) {
      setIsDownloadBarVisible(true);
    } else {
      setIsDownloadBarVisible(false);
    }
  }, []);

  useEffect(() => {
    if (userMarketPlaceHomeData?.enquiryForm) {
      if (
        window.location.pathname == "/cart" ||
        window.location.pathname == "/user-checkout" ||
        (user?.accessToken && !user?.role?.includes("Student"))
      ) {
        setShowContactBar(false);
      } else {
        setShowContactBar(true);
      }
    } else {
      setShowContactBar(false);
    }
  }, [userMarketPlaceHomeData]);

  const handleProfileClick = (e) => {
    e.stopPropagation();
    setIsProfileClicked(!isProfileClicked);
  };

  return (
    <div>
      <div
        className={`${window.innerWidth > 800
          ? `top-bar123 ${visible ? "visible" : "hidden"}`
          : ""
          }`}
        style={{ animation: visible ? "header 1.3s ease" : "" }}
      >
        {/* {isDownloadBarVisible ? <DownloadAppTopBar orgName={userMarketPlaceHomeData?.orgName} pSLink={userMarketPlaceHomeData?.pSLink} aSLink={userMarketPlaceHomeData?.aSLink} setIsDownloadBarVisible={setIsDownloadBarVisible} /> : null} */}
        {/* {showContactBar ? <ContactUsTopBar /> : <></>} */}
        <div
          className="top-bar-parent r-c-c"
          style={{
            justifyContent: "space-between",
            width: "100%",
            ...(fullWidth ? { padding: "10px 20px" } : {}),
          }}
        >
          <div
            style={{ display: "flex", cursor: "pointer" }}
            onClick={() => {
              if (setCourses) {
                const requestsParams = {
                  page: page,
                  courseType: "course",
                  limit: 3,
                };
                getUserMarketPlaceCoursesData(requestsParams, (data) => {
                  if (data?.items && data?.items?.length > 0) {
                    setCourses((prevCourses) => [...prevCourses, ...data?.items]);
                  }
                  if (data?.items?.length < requestsParams?.limit) {
                    setHasMore?.(false);
                  }
                });
              }
              if (isFromAdminPreview) {
              } else {
                history.push("/");
                setIsCategoryClicked?.(false);
                setIsProfileClicked?.(false);
                setCategories?.([]);
                SetHidBanner?.(false);
                setCategoryId?.(null);
                setPage?.(1);
                setCourses?.([]);
                userSearchData?.([]);
                autocompleteSearched?.(null);
                setSelectedSuggestion?.(null);
              }
            }}
          >
            <img
              className="vectorIcon"
              style={{ marginRight: 10 }}
              src={topBarLogoSrc}
              onError={(e) => { e.target.onerror = null; e.target.src = defaultInstituteLogo; }}
              alt="logo"
            />
            <div
              className="institute-title"
              style={{ color: "#594099", fontWeight: "bold" }}
            >
              {topBarOrgName}
            </div>
          </div>
          {/* <div className='topbar-mobile-disable'>
                        {userMarketPlaceHomeData?.categories?.length > 0 ?
                            <Dropdown overlay={userCategoryMenu} trigger={['hover']} open={isCategoryClicked}>
                                <div style={{ color: "#191919", fontWeight: 600, fontSize: 18, marginRight: 30, cursor: "pointer" }} onClick={(e) => {
                                    if (isFromAdminPreview) { }
                                    else {
                                        e.stopPropagation(); setIsCategoryClicked(!isCategoryClicked); setIsProfileClicked(false)
                                    }
                                }}>Categories{isCategoryClicked ? <CaretUpOutlined style={{ color: "#AEAEAE", marginLeft: 10 }} /> : <CaretDownOutlined style={{ color: "#AEAEAE", marginLeft: 10 }} />}</div>
                            </Dropdown> : <div></div>}
                        <AutoComplete
                            allowClear
                            popupClassName="certain-category-search-dropdown input-field"
                            style={{ marginRight: 20 }}
                            options={(userSearchDataContainer?.suggestions?.length > 0 || userSearchDataContainer?.resources?.length) ? searchOptions : []}
                            onSearch={handleAutocompleteSearch}
                            onClear={() => {
                                setSelectedSuggestion(null);
                                setAutocompleteSearchedValue(null);
                                // history.push("/home")
                            }}
                            defaultValue={autocompleteSearchedValue ? autocompleteSearchedValue : selectedSuggestion ? selectedSuggestion : null}
                            placeholder={<span><SearchOutlined /> Search</span>}
                            loading={searchLoader}
                            className='round-bordered-search-course search-width input-field'
                            disabled={isFromAdminPreview ? true : false}
                        >
                        </AutoComplete>
                    </div> */}
          {isFromAdminPreview ? (
            <Button
              onClick={() => {
                setIsFromAdminPreview(false);
                history.push("/course-details");
              }}
            >
              EXIT PREVIEW
            </Button>
          ) : (
            <div className="topbar-mobile-disable">
              {!hideCart &&
                (user?.role?.includes("Student") ||
                  user?.accessToken == undefined) ? (
                <>
                  <div
                    className="m-r-20"
                    style={{ position: "relative", cursor: "pointer" }}
                    onClick={() => {
                      setIsCategoryClicked(false);
                      setIsProfileClicked(false);
                      if (user?.accessToken) {
                        history.push("/cart");
                      } else {
                        // history.push("/login")
                        setShowLoginModal(true);
                      }
                    }}
                  >
                    <img
                      className="cartIcon"
                      style={{ marginTop: 8 }}
                      src={
                        require("../../Assets/aulasMarket/cartNew.svg").default
                      }
                    />
                    {cartCountData > 0 ? (
                      <div
                        style={{
                          backgroundColor: "#FFA931",
                          color: "#FFFFFF",
                          fontSize: 10,
                          fontWeight: "bold",
                          padding: "0px 5px",
                          borderRadius: 5,
                          height: "fit-content",
                          position: "absolute",
                          top: -2,
                          left: 20,
                        }}
                      >
                        {cartCountData}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              ) : (
                <></>
              )}
              <div
                ref={profileRef}
                style={{
                  cursor: "pointer",
                  height: "45px",
                  width: "100%",
                  border: "1px solid #916DB9",
                  padding: "7px 20px 20px 20px",
                  borderRadius: 14,
                }}
                onClick={handleProfileClick}
              >
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    cursor: "pointer",
                    gap: 10,
                  }}
                >
                  <div style={{ height: 20, marginTop: -1 }}>
                    {console.log("user?.image", user?.image)}

                    <UserAvatar
                      className={"profileIcon"}
                      name={user?.name}
                      img={
                        user?.image == "default.png"
                          ? ""
                          : user?.image
                            ? `${IMG_URL}/${user?.image}`
                            : `${IMG_URL}/${"default.png"}`
                      }
                      marketPlace={true}
                    />

                    {/* //  img={user?.image ? `${IMG_URL}/${user?.image}` : `${IMG_URL}/${'default.png'}`} */}
                  </div>
                  <div
                    style={{ color: "#191919", fontWeight: 400, fontSize: 17 }}
                  >
                    {user?.name ? user?.name : "Guest"}
                  </div>

                  {isProfileClicked && (
                    <div
                      style={{
                        background: `
            linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.8)),
            linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)
          `,
                        position: "absolute",
                        top: "100%", // Aligns the dropdown just below the user avatar div
                        right: -20, // Aligns the dropdown to the right end of the parent div
                        backgroundColor: "white",
                        boxShadow: "4px 4px 16px 8px #00000014",
                        borderRadius: 12,
                        width: 260,
                        padding: 20,
                        marginTop: 12,
                        zIndex: 1000,
                        cursor: "default",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <center style={{ marginTop: 2 }}>
                        <UserAvatar
                          size={50}
                          name={user?.name}
                          img={
                            user?.image == "default.png"
                              ? ""
                              : user?.image
                                ? `${IMG_URL}/${user?.image}`
                                : `${IMG_URL}/${"default.png"}`
                          }
                          marketPlace={true}
                        />
                      </center>
                      <center
                        style={{
                          marginTop: 10,
                          color: "#191919",
                          fontWeight: "bold",
                          fontSize: 15,
                          cursor: "default",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {user?.name ? user?.name : "Guest"}
                      </center>
                      <center
                        style={{ marginTop: 1, fontSize: 15, fontWeight: 400, cursor: "default" }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {user?.role?.[0]}
                      </center>

                      <center className='m-t-20'>
                        <Button
                          type="primary"
                          style={{
                            width: "100%",
                            padding: "10px 10px",
                            borderRadius: 8,
                            fontWeight: 700,
                            fontSize: 15,
                            height: 40,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (exploreCourses) {
                              history.push("/");
                              return;
                            }
                            // if (user?.accessToken && user?.role?.includes("Student") && !user?.student?.liveCourse) {
                            //   history.push("/courses-list");
                            // } else if (user?.accessToken && user?.role?.includes("Student") && user?.student?.liveCourse) {
                            //   history.push("/dashboard-student");
                            // } else if (user?.accessToken && !user?.role?.includes("Student")) {
                            //   history.push("/schedule");
                            // } else {
                            //   history.push("/login");
                            // }
                            if (user?.accessToken && user?.role?.includes("Student")) {

                              // The session's user.student data is only refreshed at login, so a batch
                              // assigned/unassigned afterward wouldn't show here yet - refetch it live
                              // and let this response be the single source of truth. As long as it
                              // confirms an active assignment, go straight to student-test - no need to
                              // force a fresh login/logout just because the cached session is stale.
                              fetchStudentStandards((freshData, error) => {
                                if (error) {
                                  const errorMessage = error?.show?.message;
                                  const looksLikeServerCrash = typeof errorMessage === "string" &&
                                    /cannot read propert(y|ies)|undefined is not a function|is not a function|null is not an object|is not defined|TypeError/i.test(errorMessage);
                                  if (looksLikeServerCrash) {
                                    // This is a backend bug (an unhandled server-side exception),
                                    // not proof the session/token is stale - don't demand a fresh
                                    // login over it. Fall back to what the session already knows
                                    // from login instead of refusing to answer.
                                    const cachedAssigned =
                                      (user?.student?.studentStandards?.length > 0) || user?.student?.liveCourse;
                                    if (cachedAssigned) {
                                      // The route guard on /student-test checks user.access/services from
                                      // the session cached at login, not this live check - refresh those
                                      // first so it doesn't bounce us straight back to /login.
                                      checkLiveCourse({ userId: user.id, userAccessToken: user.accessToken }, () => {
                                        history.push("/student-test");
                                      });
                                    } else {
                                      Notification.error(
                                        "Access Restricted",
                                        "No batch or live course is assigned to your account. Please contact your institute or enroll in a live course."
                                      );
                                      history.push("/home");
                                    }
                                    return;
                                  }
                                  // This endpoint 401s with the same "no class assigned" signal on
                                  // ANY assignment change - adding OR removing a batch, worded
                                  // identically whether the student now has nothing or just got
                                  // something new. There's no way to tell those apart from this
                                  // message alone, so don't guess - silently refresh the session via
                                  // the same live-course-refresh used after a course purchase, and
                                  // decide navigation from ITS answer instead.
                                  checkLiveCourse({ userId: user.id, userAccessToken: user.accessToken }, (refreshedUser) => {
                                    if (!refreshedUser) {
                                      // The refresh itself failed - fall back to an explicit relogin.
                                      Notification.success(
                                        "Assignment Changed",
                                        "Your batch/course assignment has changed. Please log in again to continue."
                                      );
                                      setShowLoginModal(true);
                                      return;
                                    }
                                    const isAssignedNow =
                                      (refreshedUser?.student?.studentStandards?.length > 0) || refreshedUser?.student?.liveCourse;
                                    if (isAssignedNow) {
                                      history.push("/student-test");
                                    } else {
                                      Notification.error(
                                        "Access Restricted",
                                        "No batch or live course is assigned to your account. Please contact your institute or enroll in a live course."
                                      );
                                      history.push("/home");
                                    }
                                  });
                                  return;
                                }
                                const studentStandards = freshData?.studentStandards;
                                const liveCourse = user?.student?.liveCourse;
                                const isAssigned = (studentStandards?.length > 0) || liveCourse;
                                if (!isAssigned) {
                                  Notification.error(
                                    "Access Restricted",
                                    "No batch or live course is assigned to your account. Please contact your institute or enroll in a live course."
                                  );
                                  history.push("/home");
                                  return;
                                }
                                // The route guard on /student-test checks user.access/services from the
                                // session cached at login, not this live check - refresh those first (same
                                // mechanism already used to grant access right after a live-course purchase)
                                // so it doesn't bounce us straight back to /login.
                                checkLiveCourse({ userId: user.id, userAccessToken: user.accessToken }, () => {
                                  history.push("/student-test");
                                });
                              }, true);
                            } else if (user?.accessToken && !user?.role?.includes("Student")) {
                              history.push("/schedule");
                            } else {
                              // history.push("/login");
                              setShowLoginModal(true)
                            }
                          }}
                        >
                          {exploreCourses ? "EXPLORE COURSES" : "MY ACCOUNT"}
                        </Button>
                      </center>

                      {user?.accessToken && (
                        <center className="m-t-20">
                          <Button
                            style={{
                              width: "100%",
                              padding: "10px 10px",
                              borderRadius: 8,
                              border: "1px solid #FF414D",
                              color: "#FF414D",
                              fontWeight: 700,
                              fontSize: 15,
                              height: 40,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setConfirmLogoutVisible(true);
                              setIsCategoryClicked(false);
                              setIsProfileClicked(false);
                            }}
                          >
                            LOGOUT
                          </Button>
                        </center>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        {/* {isOffersBarVisible && offersCarouselData?.length > 0 ?
                    <>
                        <OfferCarouselV2 offersCarouselData={offersCarouselData} onDownloadClick={scrollToFooter} fromHomePage={false}/>
                        <MobileDiscountOffersCarousel />
                    </>
                    :
                    <></>
                } */}
        {couponList?.minOffers?.[0] ? (
          <div className="applicable-offer-header">
            Add items worth ₹
            {couponList?.minOffers?.[0]?.dif?.toLocaleString() || ""} to get{" "}
            {couponList?.minOffers?.[0]?.discountType == "percent"
              ? `${couponList?.minOffers?.[0]?.discount}%`
              : `₹${couponList?.minOffers?.[0]?.discount}`}{" "}
            off above ₹
            {couponList?.minOffers?.[0]?.minPurchase?.toLocaleString()}
          </div>
        ) : null}
      </div>
      <div className="top-bar-parent-mobile">
        <div
          style={{ display: "flex" }}
          onClick={() => {
            if (isFromAdminPreview) {
            } else {
              history.push("/");
            }
          }}
        >
          <img
            className="vectorIcon"
            style={{ marginRight: 10 }}
            src={topBarLogoSrc}
            onError={(e) => { e.target.onerror = null; e.target.src = defaultInstituteLogo; }}
            alt="logo"
          />
          <div
            className="institute-title"
            style={{ color: "#594099", fontWeight: "bold" }}
          >
            {topBarOrgName}
          </div>
        </div>
        <div className="search-menu-mobile">
          <center style={{ marginRight: 20, marginTop: -3 }}>
            {console.log("user?.name", user?.name, user?.image)}
            <UserAvatar
              size={30}
              name={user?.name}
              img={
                user?.image
                  ? `${IMG_URL}/${user?.image}`
                  : `${IMG_URL}/${"default.png"}`
              }
              onClick={(e) => {
                e.stopPropagation();

                if (!user?.accessToken) {
                  setShowBottomSheet(true);
                } else {
                  setIsProfileClicked(true);
                }
              }}
            />
          </center>
          {/* <SearchOutlined style={{ color: "#AEAEAE", fontSize: 22, marginRight: 20 }} onClick={() => { if (isFromAdminPreview) { } else { history.push("/mobile-search-page") } }} /> */}
          <MenuOutlined
            style={{ color: "#AEAEAE", fontSize: 22 }}
            onClick={() => {
              if (isFromAdminPreview) {
              } else {
                setSideBarStudentHome(true);
              }
            }}
          />
        </div>
      </div>
      <LogoutConfirm
        visible={confirmLogoutVisible}
        onCancel={() => setConfirmLogoutVisible(false)}
        onConfirm={() => handleLogout(history)}
      />
      {showDownloadAppModal && (
        <DownloadAppModal
          showDownloadAppModal={showDownloadAppModal}
          setShowDownloadAppModal={setShowDownloadAppModal}
          userMarketPlaceHomeData={userMarketPlaceHomeData}
        />
      )}
      {showLoginModal && (
        <LoginModal
          showLoginModal={showLoginModal}
          setShowLoginModal={setShowLoginModal}
        />
      )}
      {showRegisterSuccessModal && (
        <SuccessModal
          showRegisterSuccessModal={showRegisterSuccessModal}
          setRegisterSuccessModal={setRegisterSuccessModal}
        />
      )}
      <PageDataLoader visible={pageLoader} />
    </div>
  );
}
const mapStateToProps = (state) => {
  const {
    userMarketPlaceHomeData,
    cartCountData,
    isLogoutClicked,
    isDownloadBarVisible,
    showContactBar,
    selectedSuggestion,
  } = state.studentMarketPlace;
  const { user } = state.session;
  const { isFromAdminPreview } = state.courseManagement;
  const { showLoginModal, showRegisterSuccessModal, showDownloadAppModal, showBottomSheet, orgData } =
    state.loginNew;
  return {
    userMarketPlaceHomeData,
    orgData,
    user,
    cartCountData,
    isLogoutClicked,
    isDownloadBarVisible,
    showContactBar,
    selectedSuggestion,
    isFromAdminPreview,
    showLoginModal,
    showRegisterSuccessModal,
    showDownloadAppModal,
    showBottomSheet,
  };
};

const mapDispatchToProps = (dispatch) => ({
  logout: (history, reason) => dispatch(logout(history, reason)),
  setSideBarStudentHome: (val) => dispatch(setSideBarStudentHome(val)),
  setParentLink: (item) => dispatch(setParentLink(item)),
  getUserCourseAutocompleteSearch: (search, callBack) =>
    dispatch(getUserCourseAutocompleteSearch(search, callBack)),
  showMenu: (bool) => dispatch(showMenu(bool)),
  getUserMarketPlaceHomeData: (noCourse, callBack) =>
    dispatch(getUserMarketPlaceHomeData(noCourse, callBack)),
  setIsLogoutClicked: (val) => dispatch(setIsLogoutClicked(val)),
  storeCartCountData: (val) => dispatch(storeCartCountData(val)),
  getCartCount: () => dispatch(getCartCount()),
  setIsMyAccountClicked: (val) => dispatch(setIsMyAccountClicked(val)),
  setIsDownloadBarVisible: (val) => dispatch(setIsDownloadBarVisible(val)),
  setShowContactBar: (val) => dispatch(setShowContactBar(val)),
  setSelectedSuggestion: (val) => dispatch(setSelectedSuggestion(val)),
  setIsFromAdminPreview: (val) => dispatch(setIsFromAdminPreview(val)),
  getUserMarketPlaceCoursesData: (requestsParams, callBack) =>
    dispatch(getUserMarketPlaceCoursesData(requestsParams, callBack)),
  setShowLoginModal: (val) => dispatch(setShowLoginModal(val)),
  setRegisterSuccessModal: (val) => dispatch(setRegisterSuccessModal(val)),
  setShowDownloadAppModal: (val) => dispatch(setShowDownloadAppModal(val)),
  setShowBottomSheet: (val) => dispatch(setShowBottomSheet(val)),
  fetchStudentStandards: (callback, suppressLogout) => dispatch(fetchStudentStandards(callback, suppressLogout)),
  checkLiveCourse: (param, callback) => dispatch(checkLiveCourse(param, callback)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TopBar);